import { Input } from 'antd';

import styles from './AppTextArea.module.scss';

const { TextArea } = Input;

const AppTextArea = ({ className = '', ...restProps }) => (
  <TextArea className={`${styles.textArea} ${className}`} {...restProps} />
);

export default AppTextArea;
